import React from 'react';
import { Create } from 'react-admin';
import MetricValueForm from '../MetricValueForm';

function MetricValueCreate(props) {
  return (
    <Create {...props}>
      <MetricValueForm redirect="list" />
    </Create>
  );
}

export default MetricValueCreate;
